<script setup lang="ts">

import '@/assets/styles/footer.css';
</script>

<template>
  <footer class="footer">
    <div class="footer-demo-note">
      <strong>Hinweis: Dies ist eine unverbindliche Website-Demo.</strong>
      <span>Die Werkstatt, Personen, Kontaktdaten und Leistungen sind fiktiv und dienen ausschließlich der Präsentation.</span>
    </div>
    <div class="footer-container">

      <div class="footer-block">
        <h3>KFZ Musterwerkstatt</h3>
        <p>
          Inhaber: Max Mustermann<br/>
          Musterstraße 12<br/>
          12345 Musterstadt
        </p>
        <p>
          Tel: <a href="tel:+491234567890">01234 567890</a><br/>
          E-Mail:
          <a href="mailto:info@musterwerkstatt.example">
            info@musterwerkstatt.example
          </a>
        </p>
      </div>

      <div class="footer-block">
        <h3>Rechtliches</h3>
        <p>
          Berufsbezeichnung: Kraftfahrzeugtechnikermeister<br/>
          Verliehen in Deutschland<br/>
          Zuständige Kammer: Handwerkskammer Musterstadt
        </p>
        <p>
          Umsatzsteuer-ID: DE123456789 (Beispielangabe)
        </p>
      </div>

      <div class="footer-block">
        <h3>Links</h3>
        <ul>
          <li><a href="/impressum">Impressum</a></li>
          <li><a href="/datenschutz">Datenschutz</a></li>
        </ul>
      </div>

    </div>

    <div class="footer-bottom">
      <p>© {{ new Date().getFullYear() }} KFZ Musterwerkstatt · Musterwebsite</p>
      <p class="creator">Keine reale Werkstatt · Alle Angaben sind Beispiele</p>
    </div>
  </footer>
</template>


<style scoped>

</style>
